<template>
  <div class="account-footer">
    <div class="footer-content">
      <span> © 2005－2020 小橙家教 蜀ICP备2022026614号 </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountFooter',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.account-footer {
    width: 100%;
    height: 60px;
    background-color: #ffffff;

    position: absolute;
    bottom: 0;

    .footer-content {
        height: 60px;
        width: $container-width;
        margin: auto;
        line-height: 60px;

        .span {
            width: 344px;
            height: 14px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 32px;
            letter-spacing: 0px;
            color: #333333;
        }
    }
}
</style>
